<!-- eslint-disable -->
<template lang="pug">
    .loss
        .loss__clevik
            img(src="../../../assets/images/battles/result/loss-clevik.png")
        .loss-box
            .loss__title {{ $i18n.t('battle.battle_loss_title') }}
            .loss__text {{ $i18n.t('battle.battle_try_more') }}
            .loss__text(v-if="isForceCompleted") {{ $i18n.t('battle.battle_you_didnt_reconnect') }}
            .loss__buttons
                cs-button(
                    type="button",
                    color="blue",
                    @click="$router.push({name: playMoreRouteString})"
                ) {{ $i18n.t('battle.battle_play_more_time') }}
                cs-button(
                    v-if="!isForceCompleted"
                    type="button",
                    color="blue",
                    pattern="primary-outline",
                    @click="$emit('showResultStats')"
                ) {{ $i18n.t('battle.battle_view_stats') }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            playMoreRouteString: {
                type: String,
                default: ''
            },
            isForceCompleted: {
                type: Boolean,
                default: false
            },
        }
    }
</script>

<style scoped lang="scss">
    .loss {
        margin: 30px 0;
        text-align: center;
        color: #333333;
    }
    .loss__clevik {
        height: 185px;
    }
    .loss-box {
        background: #F7F7FF;
        border-radius: 20px;
        white-space: nowrap;
        max-width: 460px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 25px 125px 30px 125px;
        @media screen and (max-width: 576px) {
            padding: 25px 55px 30px 55px;
        }
        @media screen and (max-width: 576px) {
            padding: 25px 30px 30px 30px;
        }
    }
    .loss__title {
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 5px;
    }
    .loss__text {
        font-size: 16px;
        line-height: 30px;
    }
    .loss__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        @include media($md) {
            flex-direction: row;
            justify-content: center;
        }
    }
    .loss__buttons .cs-button:nth-child(2) {
        margin: 20px 0 0 0;
        @include media($md) {
            margin: 0 0 0 20px;
        }
    }
</style>
